module.exports = __webpack_public_path__ + "img/thehairshop.69c3f81e.jpg";